import { render } from "./errorToken.vue?vue&type=template&id=a92263fa&scoped=true"
import script from "./errorToken.vue?vue&type=script&lang=js"
export * from "./errorToken.vue?vue&type=script&lang=js"

import "./errorToken.vue?vue&type=style&index=0&id=a92263fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92263fa"]])

export default __exports__